import { useAuth } from "@dl/web-core-js/auth";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { InvoiceClient } from "../../api/invoice";
import type { ProductDTO } from "../../api/product";
import { InvoicesTable } from "../../components/InvoicesTable";
import { isoDate } from "../../api/reporting";

/**
 * Invoices containing this SKU, over the same trailing window the Vaadin tab
 * used: two full years back through today.
 */
export function InvoicesTab({ draft }: { draft: ProductDTO }) {
  const { http } = useAuth();
  const client = useMemo(() => new InvoiceClient(http), [http]);
  const sku = draft.metadata?.sku ?? "";

  const period = useMemo(() => {
    const now = new Date();
    return { from: `${now.getFullYear() - 2}-01-01`, to: isoDate(now) };
  }, []);

  const { data, isLoading } = useQuery({
    queryKey: ["invoice", "by-part", sku, period.from],
    queryFn: () => client.byPeriodAndPart(sku, period),
    enabled: sku !== "",
    staleTime: 5 * 60_000,
  });

  return (
    <InvoicesTable data={data ?? []} loading={isLoading} />
  );
}
